module.exports = __webpack_public_path__ + "images/sponsored-blue-fbc893e9.svg";